<template>
	<div class="about-page">

		<section class="about-hero">
			<div class="about-content center-content">
				<h1>About Us</h1>
				<h2>We Believe the Ocean Should Be Accessible to Everyone</h2>

				<p>
					Fathom Ocean develops underwater monitoring systems that help organizations
					and individuals observe, understand, and protect marine environments.
				</p>

				<p>
					From scientific research and infrastructure monitoring to public education
					and waterfront experiences, our technology creates a reliable connection
					to the world beneath the surface.
				</p>
			</div>
		</section>

		<section class="about-section mission-section">
			<div class="about-content center-content">
				<div class="pink-line"></div>

				<h2>Our Mission</h2>
				<p class="large-copy">
					To make underwater environments visible, accessible, and understandable
					through innovative monitoring technology.
				</p>
			</div>
		</section>

		<section class="about-section people-section">
	<div class="about-content">
		<div class="pink-line"></div>

		<h2>Leadership</h2>

		<div class="leadership-grid">
			<div class="person-card person-card--trevor">
				<figure><img src="@/assets/images/trevor.png" alt="Trevor Mendelow" loading="lazy" decoding="async"></figure>
				<h3>Trevor Mendelow</h3>
				<h4>Founder & President</h4>
				<p>
					Trevor founded Fathom Ocean with a simple goal: make long-term underwater
					monitoring more reliable, accessible, and useful for scientists, resource managers,
					utilities, and coastal organizations. Over the past two decades, he has led the
					development of underwater camera systems deployed around the world for
					environmental monitoring, marine research, infrastructure inspection, and public
					engagement. Trevor oversees product development, strategic partnerships, and client
					relationships, while continuing to drive innovation in underwater imaging,
					communications, and AI-assisted monitoring technologies.
				</p>
			</div>

			<div class="person-card person-card--amy">
				<figure><img src="@/assets/images/amy.png" alt="Amy Beyer" loading="lazy" decoding="async"></figure>
				<h3>Amy Beyer</h3>
				<h4>COO and Sales Director</h4>
				<p>
					Amy manages day-to-day operations at Fathom Ocean and serves as a primary point of
					contact for clients throughout the lifecycle of a project. From proposal development and
					project coordination to deployment logistics and customer support, she helps ensure
					that every project is delivered efficiently and successfully. Her strong organizational
					skills, attention to detail, and commitment to customer service help keep projects
					moving smoothly while maintaining the high standards that clients have come to expect
					from Fathom Ocean.
				</p>
			</div>
		</div>

		<h2 class="team-title">Team</h2>

		<div class="team-grid">
			<div class="person-card">
				<figure><img src="@/assets/images/kyle.png" alt="Kyle Mendelow" loading="lazy" decoding="async"></figure>
				<h3>Kyle Mendelow</h3>
				<h4>Technical Director</h4>
				<p>
					Kyle leads the technical development and integration of Fathom Ocean's monitoring
					platforms, communications systems, and software infrastructure. His expertise spans
					underwater imaging, networking, data management, and system deployment, helping
					bridge the gap between hardware and software solutions. Kyle works closely with clients
					and field teams to design reliable monitoring systems while supporting the development
					of advanced capabilities including remote monitoring, automation, and AI-assisted data analysis.
				</p>
			</div>

			<div class="person-card">
				<figure><img src="@/assets/images/izzy.jpg" alt="Izzy Perez" loading="lazy" decoding="async"></figure>
				<h3>Izzy Perez</h3>
				<h4>Manufacturing Technician</h4>
				<p>
					Izzy is responsible for the assembly, testing, and quality control of Fathom Ocean's
					camera systems. She plays a key role in preparing equipment for factory authorized
					testing and deployment, and ensures that each system meets our performance and
					reliability standards before it reaches the field. Her attention to detail helps maintain the
					quality and consistency our clients expect from every Fathom Ocean product.
				</p>
			</div>

			<div class="person-card">
				<figure><img src="@/assets/images/tim.jpg" alt="Tim Sadowski" loading="lazy" decoding="async"></figure>
				<h3>Tim Sadowski</h3>
				<h4>Field Technician & IT Consultant</h4>
				<p>
					Based in Florida, Tim supports Fathom Ocean's field operations throughout the 
					southeastern United States. He is responsible for the installation, maintenance, 
					troubleshooting, and servicing of underwater camera systems and monitoring platforms,
					including deployments at critical infrastructure facilities such as Florida Power & Light 
					(FPL). With extensive hands-on experience in marine environments, Tim helps ensure
					our systems remain operational and deliver reliable data in the field.
				</p>
		</div>
		</div>
	</div>
</section>

		<section class="about-section consult-section center-content">
			<div class="about-content">
				<h2>Get In Touch</h2>
				<p class="large-copy">
					Have a question, want a demo, or need help planning a deployment?
				</p>

				<b-button @click="$router.push('/contact')">
					Request a Consultation
				</b-button>
			</div>
		</section>

	</div>
</template>

<script>
export default {
	name: 'About'
}
</script>
